import { Box, Image } from "@chakra-ui/react";
import React from "react";
import Colors from "../../../assets/colors/Colors";

const BoxForPaymentMethode = ({ icon }) => {
    return (
        <Box
            w={{ base: "20%", sm: "4.625rem" }}
            h={"2.375rem"}
            borderRadius="7px"
            border="1px"
            borderColor={Colors.grubPaymentMethodIconBorderColor}
            display="flex"
            alignItems="center"
            justifyContent="center"
        >
            <Image src={icon} />
        </Box>
    );
};

export default BoxForPaymentMethode;